import { MainPostState } from './main-post-reducer';

export const getMainPost = (state: {
  mainPost: MainPostState;
}): MainPostState => state.mainPost;
